const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? 'http://127.0.0.1:8787';

type LineUserItem = {
  lineUserId: string;
  displayName: string | null;
  isFollowing: boolean;
  linkedUserId: string | null;
  updatedAt: string;
};

async function throwIfNotOk(response: Response) {
  if (response.ok) return;
  const payload = await response.json().catch(() => ({}));
  const message = typeof payload.message === 'string' ? payload.message : 'API request failed';
  throw new Error(message);
}

export async function fetchLineUserList() {
  const response = await fetch(`${apiBaseUrl}/api/admin/integrations/line/users`);
  await throwIfNotOk(response);
  const payload = (await response.json()) as { users: LineUserItem[] };
  return payload.users;
}

export async function pushLineMessage(input: {
  message: string;
  lineUserIds?: string[];
  onlyFollowing?: boolean;
}) {
  const response = await fetch(`${apiBaseUrl}/api/admin/integrations/line/push`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...input,
      onlyFollowing: input.onlyFollowing ?? true,
    }),
  });
  await throwIfNotOk(response);
  const payload = (await response.json()) as { result: { successCount: number } };
  return payload.result;
}
